import { SealingService } from '../connections';

interface Base64Image {
  readonly url: string;
}

export function create(name: string, base64Image: string): Promise<Base64Image> {
  return SealingService.post('base64images', {
    data: {
      name,
      data: base64Image,
    },
  });
}
